<template>
  <div class="row">
    <div class="col-md-12">
      <modal :show.sync="ModalRestaurant">
        <template slot="header">
          <h5 class="modal-title sub_title" v-if="btn_create">Crear Restaurante</h5>
          <h5 class="modal-title sub_title" v-if="btn_update">Editar Restaurante</h5>
        </template>
        <ValidationObserver v-slot="{ invalid }">
          <form @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-4 tp-restaurant">
                    <label> Tipo de restaurante</label>
                    <div class="radio-default-acre">
                      <PrettyRadio name="sede" v-model="sede" :value="false">Restaurante</PrettyRadio>
                      <PrettyRadio name="sede" v-model="sede" :value="true">Sede</PrettyRadio>
                    </div>
                  </div>
                  <div class="col-4">
                    <div v-if="sede">
                      <label class="typo__label">Restaurante</label>
                      <multiselect
                          v-model="sede_restaurant"
                          track-by="restaurant_parent_id"
                          label="name"
                          placeholder="Seleccione uno"
                          :options="sedes"
                          :searchable="true"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-4">
                    <div v-if="sede">
                      <label class="typo__label">Repartidor</label>
                      <multiselect
                          v-model="dealer"
                          :options="dealers"
                          :custom-label="customLabel"
                          :searchable="true"
                          :multiple="true"
                          :close-on-select="true"
                          track-by="user_id" label="last_name"
                          placeholder="Seleccionar uno">
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-4">
                    <label for="name">Nombre</label>
                    <ValidationProvider name="restaurant.name" rules="required" v-slot="{ errors }">
                      <input
                          id="name"
                          v-model="restaurant.name"
                          type="text"
                          class="form-control"
                          placeholder="Nombre"
                      >
                      <p>{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>
                  <div class="col-4" v-if="sede">
                    <ValidationProvider name="discount_id" rules="required"
                                        v-slot="{ errors }">
                      <label class="typo__label">Descuento</label>
                      <multiselect v-model="selectdiscount"
                                   :options="descounts"
                                   :searchable="false"
                                   :close-on-select="true"
                                   :show-labels="false"
                                   label="description"
                                   placeholder="Seleccionar un descuento"
                                   class="mt-2"
                      >

                      </multiselect>
                      <p>{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>
                  <div class="col-4" v-if="sede">
                    <label for="name">Id Cliente</label>
                    <input
                        id="idcliente"
                        v-model="restaurant.reference_id"
                        type="number"
                        class="form-control"
                        placeholder="Id Cliente"
                    >
                  </div>
                  <div class="col-4" v-if="sede">
                    <label for="name">Documento</label>
                    <input
                        id="docuemento"
                        v-model="restaurant.nit"
                        type="number"
                        class="form-control"
                        placeholder="Documento"
                    >
                  </div>
                  <div class="col-4">
                    <label for="address">Dirección</label>
                    <ValidationProvider name="restaurant.address"
                                        v-slot="{ errors }">
                      <input
                          id="address"
                          v-model="restaurant.address"
                          type="text"
                          class="form-control"
                          placeholder="Dirección"
                      >
                      <p>{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>
                  <div class="col-4">
                    <label for="phone">Teléfono</label>
                    <ValidationProvider name="restaurant.phone"
                                        v-slot="{ errors }">
                      <input
                          id="phone"
                          v-model="restaurant.phone"
                          type="number"
                          class="form-control"
                          placeholder="Teléfono"
                      >
                      <p>{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>

                  <div class="col-4">
                    <ValidationProvider name="CountrySelect" rules="required"
                                        v-slot="{ errors }">
                      <label class="typo__label">País</label>
                      <multiselect
                          v-model="CountrySelect"
                          track-by="country_id"
                          label="name"
                          placeholder="Seleccione Un País"
                          :options="Country"
                          :searchable="true"
                      >
                      </multiselect>
                      <p>{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>
                  <div class="col-4">
                    <div v-if="CountrySelect != null && statefilter.length > 0 || edit === true">
                      <ValidationProvider name="StateSelect" rules="required"
                                          v-slot="{ errors }">
                        <label class="typo__label">Departamento</label>
                        <multiselect
                            v-model="StateSelect"
                            track-by="state_id"
                            label="name"
                            :custom-label="customLabelDepart"
                            @change="CountrySelect" placeholder="Seleccionar uno"
                            :options="statefilter"
                            :searchable="true"
                        >

                        </multiselect>
                        <p>{{ errors[0] }}</p>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-4">
                    <div v-if="StateSelect != null && cityfilter.length > 0 || edit === true">
                      <ValidationProvider name="CitySelect" rules="required"
                                          v-slot="{ errors }">
                        <label class="typo__label">Ciudad</label>
                        <multiselect
                            v-model="CitySelect"
                            track-by="city_id"
                            label="name"
                            placeholder="Select one"
                            :options="cityfilter"
                            :searchable="true"
                        >
                        </multiselect>
                        <p>{{ errors[0] }}</p>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-12" v-if="error">
                    <base-alert type="warning">
                      <strong>{{ error }}</strong>
                    </base-alert>
                  </div>
                  <div class="col-12">
                    <base-button id="btn_create" type="primary btn_submit" v-show="btn_create"
                                 @click="create()"
                                 :disabled="invalid">Crear
                    </base-button>
                    <base-button id="btn_update" type="primary btn_submit" v-show="btn_update"
                                 @click="update()"
                                 :disabled="invalid">Aceptar
                    </base-button>
                  </div>


                </div>
              </div>

            </div>
            <base-progress v-show="progress > 0" type="success" :height="8" :value="progress"
                           label="Guardando"></base-progress>
          </form>
        </ValidationObserver>


        <template slot="footer">
        </template>

      </modal>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {bus} from "./bus-restaurant";
import {restaurant_service} from "../../services/restaurant/RestaurantService";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import swal from 'sweetalert';
import PrettyRadio from 'pretty-checkbox-vue/radio';

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})

export default {
  name: "CreateRestaurant",
  components: {ValidationProvider, ValidationObserver, PrettyRadio},
  data() {
    return {
      progress: 0,
      dealer: [],
      error: '',
      selectdiscount: {discounts_id: 1, percent: 0, name: 'L1', description: 'Sin Descuento'},
      edit: false,
      sede: null,
      btn_update: false,
      btn_create: true,
      ModalRestaurant: false,
      Country: [],
      State: [],
      City: [],
      sedes: [],
      dealers: [],
      descounts: [],
      sede_restaurant: [],
      statefilter: [],
      cityfilter: [],
      CitySelect: {},
      StateSelect: {},
      CountrySelect: {},
      restaurant: {
        name: '',
        phone: '',
        address: '',
        reference_id: 0,
        nit: null,
        Discounts: null,
        parent: {
          restaurant_id: null
        },
        user: [],
        City: {
          city_id: 0
        }
      },
      restaurantedit: {
        restaurant_id: 0,
        name: '',
        phone: '',
        address: '',
        reference_id: 0,
        nit: null,
        Discounts: null,
        parent: {
          restaurant_id: null
        },
        user: [],
        City: {
          city_id: 0
        }
      }

    }
  },
  watch: {
    //Lista departamento
    'CountrySelect': function () {
      this.statefilter = _.filter(this.State, (c) => {
        if (c.country.country_id === this.CountrySelect.country_id) {
          return c
        }
      })
    },
    //Lista ciudad
    'StateSelect': function () {
      this.cityfilter = _.filter(this.City, (c) => {
        if (c.State.state_id === this.StateSelect.state_id) {
          return c
        }
      })
      this.error = ''
    }
  },

  methods: {
    onSubmit() {
      alert('Form has been submitted!');
    },
    customLabel({name, last_name}) {
      return `${name} ${last_name}`
    },
    customLabelDepart({name}) {
      return _.capitalize(name)
    },
    //abre modal de crear
    ShowRestaurant() {
      this.cleanform()
      this.ModalRestaurant = !this.ModalRestaurant
      this.CountrySelect = {
        "country_id": 52,
        "iso": "CO",
        "name": "Colombia"
      }
      this.StateSelect = {
        "state_id": 5,
        "name": "ANTIOQUIA"
      }
    },
    create() {
      if (this.CitySelect.city_id > 0) {
        this.restaurant.parent.restaurant_id = null
        if (this.sede === true) {
          this.restaurant.parent.restaurant_id = this.sede_restaurant.restaurant_id
          this.restaurant.user = this.dealer
          this.restaurant.Discounts = this.selectdiscount.discounts_id
        }
        this.restaurant.City.city_id = this.CitySelect.city_id
        this.progress = 50
        restaurant_service.CreateRestaurant(this.restaurant)
        //console.log(this.restaurant)
        this.sede = false
      } else {
        this.error = 'Debes Seleccionar el Pais - Departamento - Ciudad'
      }


    },
    update() {
      if (this.restaurantedit.restaurant_id > 0) {
        this.restaurantedit.name = this.restaurant.name
        this.restaurantedit.phone = this.restaurant.phone
        this.restaurantedit.address = this.restaurant.address
        this.restaurantedit.parent.restaurant_id = null
        this.restaurantedit.nit = this.restaurant.nit
        this.restaurantedit.reference_id = this.restaurant.reference_id

        if (this.sede === true) {
          this.restaurantedit.parent.restaurant_id = this.sede_restaurant.restaurant_id
          this.restaurantedit.Discounts = this.selectdiscount.discounts_id
          let users = []
          if (this.restaurant.user != null) {
            users = _.filter(this.restaurant.user, (u) => {
              return u.user_type_id.user_type_id !== 4
            })
          }
          for (const prop in this.dealer) {
            users.push(this.dealer[prop])
          }

          this.restaurantedit.user = users
        } else {
          this.restaurantedit.user = this.restaurant.user
        }
        if (this.CitySelect.city_id === undefined) {
          const city = this.CitySelect
          for (const prop in city) {
            this.restaurantedit.City = city[prop].city_id
          }
        } else {
          this.restaurantedit.City.city_id = this.CitySelect.city_id
        }

        this.progress = 50
        restaurant_service.UpdateRestaurant(this.restaurantedit)


      }
    },
    responsecreate(response) {
      if (response.statusText === "Created") {
        this.progress = 100
        this.cleanform()
        this.ShowRestaurant()
        swal({
          icon: "success",
          text: "Restaurante Registrado Correctamente",
          button: "Aceptar"
        })
      } else {
        swal({
          dangerMode: true,
          icon: "error",
          text: "Restaurante No Se Ha Registrado Correctamente",
          button: "Aceptar"
        })
      }

    },
    responseupdate(response) {
      if (response.status === 200) {
        this.progress = 100
        this.cleanform()
        this.ShowRestaurant()
        swal({
          icon: "success",
          text: "Restaurante Actualizado Correctamente",
          button: "Aceptar"
        })
      } else {
        swal({
          dangerMode: true,
          icon: "error",
          text: "Restaurante No Se Ha Actualizado Correctamente",
          button: "Aceptar"
        })
      }

    }, cleanform() {
      this.progress = 0
      this.restaurant.name = ''
      this.restaurant.phone = ''
      this.restaurant.address = ''
      this.restaurant.reference_id = 0
      this.restaurant.Discounts = null
      this.restaurant.nit = null
      //this.restaurant.restaurant_parent_id = 0
      this.CitySelect = {}
      this.StateSelect = {}
      this.CountrySelect = {}
      this.sede = null
      this.sede_restaurant = null
      this.edit = false
      this.btn_create = true
      this.btn_update = false
      this.restaurantedit = {
        restaurant_id: 0,
        name: '',
        phone: '',
        address: '',
        parent: {
          restaurant_id: null
        },
        user: [],
        City: {
          city_id: 0
        },
        reference_id: 0,
        nit: null,
        Discounts: null
      }
      this.error = ''
      restaurant_service.GetAllRestaurant()
      restaurant_service.GetAllSedes()
      restaurant_service.GetAllCountry()
      restaurant_service.GetAllState()
      restaurant_service.GetAllCity()
      restaurant_service.GetAllrestaurantFull()
      restaurant_service.GetAllDealer()
      restaurant_service.GetAllDiscounts()
    },

  },
  created() {
    restaurant_service.GetAllCountry()
    restaurant_service.GetAllState()
    restaurant_service.GetAllCity()
    restaurant_service.GetAllrestaurantFull()
    restaurant_service.GetAllDealer()
    restaurant_service.GetAllDiscounts()
    bus.$on('ShowRestaurant', () => {
      this.ShowRestaurant()
    })
    bus.$on('GetAllDiscounts', (response) => {
      this.descounts = response
    })
    bus.$on('GetAllCountry', (response) => {
      this.Country = response
    })
    bus.$on('GetAllState', (response) => {
      this.State = response
    })
    bus.$on('GetAllCity', (response) => {
      this.City = response
    })

    bus.$on('ResponseCreateRestaurant', (response) => {
      restaurant_service.GetAllRestaurant(),
          this.responsecreate(response)
    })
    bus.$on('ResponseUpdateRestaurant', (response) => {
      restaurant_service.GetAllRestaurant(),
          this.responseupdate(response)
    })
    bus.$on('GetAllrestaurantFull', (restaurants) => {
      this.sedes = restaurants
    })
    bus.$on('GetAllDealer', (response) => {
      this.dealers = response
    })
    bus.$on('GetEditRestaurant', (restaurantedit) => {
      restaurant_service.GetAllRestaurant()
      this.ShowRestaurant();
      this.btn_create = false
      this.btn_update = true
      this.restaurantedit.restaurant_id = restaurantedit.restaurant_id
      this.restaurant.name = restaurantedit.name
      this.restaurant.phone = restaurantedit.phone
      this.restaurant.address = restaurantedit.address
      this.restaurant.user = restaurantedit.user
      this.restaurant.reference_id = restaurantedit.reference_id
      this.restaurant.nit = restaurantedit.nit
      this.selectdiscount = restaurantedit.Discounts
      this.CitySelect = {}
      this.StateSelect = {}
      this.CountrySelect = {}
      if (restaurantedit.parent != undefined) {
        if (restaurantedit.parent.restaurant_id > 0) {
          this.sede = true
          this.sede_restaurant = restaurantedit.parent
          const dealers = _.filter(restaurantedit.user, (u) => {
            return u.user_type_id.user_type_id === 4
          })
          this.dealer = dealers
        }
      }

      if (restaurantedit.City.city_id > 0) {
        this.edit = true
        const cityget = _.filter(this.City, (r) => {
          if (r.city_id === restaurantedit.City.city_id) {
            return r
          }
        })

        const stateget = _.filter(this.State, (r) => {
          if (r.state_id === cityget[0]['State'].state_id) {
            return r
          }
        })
        const countryget = _.filter(this.Country, (r) => {
          if (r.country_id === stateget[0]['country'].country_id) {
            return r
          }
        })

        this.statefilter = _.filter(this.State, (c) => {
          if (c.country.country_id === stateget[0]['country'].country_id) {
            return c
          }
        })

        this.cityfilter = _.filter(this.City, (c) => {
          if (c.State.state_id === cityget[0]['State'].state_id) {
            return c
          }
        })
        this.CountrySelect = countryget
        this.StateSelect = stateget
        this.CitySelect = cityget

      }


    })

  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
@media screen and (min-width: 300px) and (max-width: 1001px) {
  .modal-body form .col-12 {
    padding: 0;
  }

  .modal-body form .col-12 > div.row {
    display: block;
  }

  .modal-body form .col-12 > div.row > div {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0;
  }

  .modal-body form .col-12 > div.row > div label {
    width: 100%;
    text-align: left;
  }

  .modal-body form .col-12 > div.row > div .radio-default-acre {
    display: flex;
  }

  .modal-body form .col-12 > div.row > div .radio-default-acre div:first-child {
    margin: 0 5px 0 auto;
  }

  .modal-body form .col-12 > div.row > div .radio-default-acre div:last-child {
    margin: 0 4em 0 5px;
  }

  .modal-body form .col-12 > div.row > div.tp-restaurant {
    margin-bottom: 1em;
  }
}
</style>
